import levelData from './data/levelMilestones.json';
import React, { useState } from 'react';

const getLvlFromXP = (currentXP, baseLvl) => {
  console.log('Current XP:', currentXP);
  console.log('Base Level:', baseLvl);
    let level = baseLvl;
    for (let i = 0; i < levelData.length; i++) {
      if (currentXP >= levelData[i].exp) {
        level = levelData[i].level;
      } else {
        break; // Arrête la boucle dès qu'on dépasse l'XP
      }
    }
    return level;
  };

export default getLvlFromXP;